import React from "react";

const STEPS = [
  { id: 1, label: "Paste List" },
  { id: 2, label: "Review Matches" },
  { id: 3, label: "Cheapest Basket Summary" },
];

export default function PasteListStepper({ currentStep = 1 }) {
  return (
    <div className="w-full overflow-x-auto">
      <div className="mx-auto flex min-w-[280px] max-w-3xl items-center justify-between gap-2 px-1">
        {STEPS.map((step, index) => {
          const isDone = currentStep > step.id;
          const isActive = currentStep === step.id;
          return (
            <React.Fragment key={step.id}>
              <div className="flex min-w-0 flex-1 flex-col items-center gap-2 text-center">
                <div
                  className={[
                    "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[18px] font-medium",
                    isDone
                      ? "bg-[#0d9499] text-white"
                      : isActive
                      ? "bg-[#0d9499] text-white"
                      : "border-2 border-[#D7DEE8] bg-white text-[#6E7B86]",
                  ].join(" ")}
                >
                  {isDone ? (
                    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M5 12l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    step.id
                  )}
                </div>
                <span
                  className={[
                    "text-[12px] font-medium leading-tight sm:text-[14px] md:text-[16px]",
                    isActive || isDone ? "text-[#24303A]" : "text-[#6E7B86]",
                  ].join(" ")}
                >
                  {step.id === 3 ? (
                    <>
                      <span className="sm:hidden">Summary</span>
                      <span className="hidden sm:inline">{step.label}</span>
                    </>
                  ) : (
                    step.label
                  )}
                </span>
              </div>
              {index < STEPS.length - 1 && (
                <div
                  className={[
                    "mb-6 h-0.5 w-6 shrink-0 rounded-full sm:w-10",
                    currentStep > step.id ? "bg-[#0d9499]" : "bg-gray-300",
                  ].join(" ")}
                  aria-hidden
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
